import React from "react";
import { Button, FormFieldSet, SmartTooltip } from "../../../../components";

const InvoiceFilters = ({
  selEmployees,
  setSelEmployees,
  selClients,
  setSelClients,
  dateRange,
  setDateRange,
}) => {
  return (
    <div className="flex flex-wrap items-center w-full gap-1">
      <div className="w-60">
        <FormFieldSet
          type="employees"
          showSearch={true}
          value={selEmployees}
          onChange={(val) => {
            setSelEmployees(val);
            setSelClients("");
          }}
          placeholder="Employee name"
          noTitle
          size="sm"
        />
      </div>
      <div className="w-60">
        <FormFieldSet
          type={selEmployees ? "allInvoiceClients" : "allClientsList"}
          showSearch={true}
          value={selClients}
          onChange={(val) => setSelClients(val)}
          placeholder="Client name"
          noTitle
          size="sm"
          filters={{
            employeeId: selEmployees?.value || "",
          }}
        />
      </div>
      <div className="w-32">
        <FormFieldSet
          type="datepicker"
          value={dateRange?.from || null}
          onChange={(val) => setDateRange((prev) => ({ ...prev, from: val }))}
          placeholder="From Date"
          noTitle
          size="sm"
          showDropdown={false}
        />
      </div>
      <div className="w-32">
        <FormFieldSet
          type="datepicker"
          value={dateRange?.to || null}
          onChange={(val) => setDateRange((prev) => ({ ...prev, to: val }))}
          placeholder="To Date"
          noTitle
          size="sm"
          showDropdown={false}
        />
      </div>
      <div className="flex-shrink-0">
        <SmartTooltip description="Clear" noicon tooltipPosition="bottom">
          <Button
            type="icon"
            icon="cancel"
            variant="text"
            color="black"
            className="hover:text-danger-500!"
            size="md"
            onClick={() => {
              setDateRange({ from: null, to: null });
              setSelEmployees("");
              setSelClients("");
            }}
          />
        </SmartTooltip>
      </div>
    </div>
  );
};

export default InvoiceFilters;
